import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import { AssignedSeatCartItemProps } from "./AssignedSeatCartItem.props";

const AssignedSeatCartItem = ({
  segment_identifier = undefined,
  location_identifier = undefined,
  identifier = undefined,
  quantity,
}: AssignedSeatCartItemProps) => {
  const { t } = useTranslation("common");

  if (!identifier && !location_identifier && !segment_identifier) return null;

  return (
    <Box paddingLeft="none">
      <Flex
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        my={1}
      >
        <Box display="grid" gridTemplateColumns="1fr 1fr 1fr">
          {segment_identifier && (
            <Box>
              <Text fontWeight={400} fontSize="sm">
                {t("Section")}
              </Text>
              <Text fontSize="sm"> {segment_identifier}</Text>
            </Box>
          )}
          {location_identifier && (
            <Box ml={3}>
              <Text fontWeight={400} fontSize="sm">
                {/* When there is no identifier (Seat) then assume that this is a general area */}
                {identifier ? t("Row") : t("Area")}
              </Text>
              <Text fontSize="sm"> {location_identifier}</Text>
            </Box>
          )}
          {identifier && (
            <Box ml={6}>
              <Text fontWeight={400} fontSize="sm">
                {t("Seat")}
              </Text>
              <Text fontSize="sm"> {identifier}</Text>
            </Box>
          )}
          {quantity && (
            <Box ml={6}>
              <Text fontWeight={400} fontSize="sm">
                {t("Qty")}
              </Text>
              <Text fontSize="sm"> {quantity}</Text>
            </Box>
          )}
        </Box>
      </Flex>
    </Box>
  );
};
export default AssignedSeatCartItem;
